import { useParams, useNavigate } from "react-router-dom";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { useState } from "react";
import NavButton from "../components/NavButton";
import { solutions } from "../data/solutionsData";
import { BsArrowLeftSquareFill } from "react-icons/bs";

function Solutions(){
    const {solutionName, sub1, sub2} = useParams();
    const navigate = useNavigate();
    const root = solutions[solutionName];
    const [selectedImg, setSelectedImg] = useState(null);

    if(!root){
        return(
            <div>
                <NavBar/>
                <main style={{ textAlign: "center", padding: "5rem" }}>
                    <h1>Solution Not Found</h1>
                    </main>
                <Footer/>
            </div>
        );
    }

    const pathParts = [sub1, sub2].filter(Boolean);

    let solution = root;
    for(const part of pathParts){
        if(!solution?.subsolutions?.[part]){
            solution = null;
            break;
        }
        solution = solution.subsolutions[part];
    }

    if(!solution){
        return(
            <div>
                <NavBar/>
                <main style={{ textAlign: "center", padding: "5rem" }}>
                    <h1>Solution Not Found</h1>
                    </main>
                <Footer/>
            </div>
        );
    }

    const basePath= "/gallery/" + [solutionName, sub1, sub2].filter(Boolean).join("/");

    const showParentInfoWithChildren = solutionName === "implants";

    return (
        <div className='page-wrapper'>
            <NavBar/>
            <main>
                <div>
                    <BsArrowLeftSquareFill className='back' onClick={() => navigate('/gallery')} size={"2.5rem"}/>
                    <h1>{solution.title}</h1>
                </div>
                
                

                {basePath=='/gallery/allceramic/fullcontourzirconiacrownandbridge' ? (
                    <>
                        <div style={{width: '90%', marginLeft: '5%'}}>
                            <p>We offer three Zirconia options, varying in strength and translucency.</p>
                            <div className='all-ceramic-div'>
                                <hr style={{width: '100%', height: '.25rem', backgroundColor: '#015A96'}}/>
                                <div>
                                    <h2><span style={{fontWeight: 'bold'}}>ArgenZ HT</span></h2>
                                    <h3><span style={{fontWeight: 'bold'}}>High Translucent</span> - Increased Strength</h3>
                                    <div>
                                        <img className='all-ceramic-img' src='/img/full-contour-zirconia.png' alt='HTML Multi-Layered Zirconia' onClick={() => navigate("/gallery/allceramic/fullcontourzirconiacrownandbridge/HTMLmultilayeredzirconia")}/>
                                        
                                        <div>
                                            <p>Osseo's Full Strength Zirconia restorations use multi-layered high-strength Zirconia with flexural strength exceeding 1200 mPa.</p>
                                            <p>Features</p>
                                            <ul>
                                                <li>Class 4 for Yttria (Translucency around 41%)</li>
                                                <li>Used for All-on-X cases</li>
                                                <li>Molars, long-span bridges</li>
                                                <li>Chip-resistant</li>
                                                <li>Smooth surface</li>
                                                <li>Designed and milled with Cad-Cam Technology</li>
                                                <li>Outstanding strength where it counts</li>
                                                <li>Approximately 1200 mPa in strength</li>
                                            </ul>
                                        </div>
                                        <img className='all-ceramic-img-2' src='/img/ht-disk.png' alt='HT Disk'/>
                                    </div>
                                </div>
                                <hr style={{width: '100%', height: '.25rem', backgroundColor: '#015A96'}}/>
                                <div>
                                    <h2><span style={{fontWeight: 'bold'}}>Yo-ML</span></h2>
                                    <h3><span style={{fontWeight: 'bold'}}>Yttrium-Optimized</span> - Best of Strength and Translucency</h3>
                                    <div>
                                        <img className='all-ceramic-img' src='/img/all-ceramic/IMG_4160.jpeg' alt='Yttrium-Optimized Hybrid Multi-Layered Zirconia' onClick={() => navigate("/gallery/allceramic/fullcontourzirconiacrownandbridge/YttriumOptimizedHybridMultiLayeredZirconia")}/>
                                        
                                        <div>
                                            <p>Osseo's Yttrim-Optimized Zirconia delivers the optimal balance fo strenth and natural esthetics. The best all-around choice for Zirconia.</p>
                                            <p>Features</p>
                                            <ul>
                                                <li>Best of both worlds - 4Y strength with 5Y translucency</li>
                                                <li>4Y 1200 mPa strength for body and gingival</li>
                                                <li>5Y 750 mPa strenth for incisal translucency (49%)</li>
                                                <li>Fabricated with Cad-Cam Technology</li>
                                                <li>Single tooth to full mouth restorations</li>
                                            </ul>
                                        </div>
                                        <img className='all-ceramic-img-2' src='/img/yo-2.png' alt='Yo Disk'/>
                                    </div>
                                    
                                    
                                </div>
                                <hr style={{width: '100%', height: '.25rem', backgroundColor: '#015A96'}}/>
                                <div>
                                    <h2><span style={{fontWeight: 'bold'}}>XTML</span></h2>
                                    <h3><span style={{fontWeight: 'bold'}}>Extra Translucent</span> - Increased Translucency</h3>
                                    <div>
                                        <img className='all-ceramic-img' src='/img/xtml-multi-layered-zirconia.png' alt='XTML Multi-Layered Zirconia' onClick={() => navigate("/gallery/allceramic/fullcontourzirconiacrownandbridge/XTMLMultiLayeredZirconia")}/>
                                        
                                        <div>
                                            <p>Osseo's XTML is a high-strength Zirconia at approximately 750 mPa. With its increased translucency layering it is ideally suited for anterior restorations and smaller span 3 unit bridges needing increased aesthetics.</p>
                                            <p>Features</p>
                                            <ul>
                                                <li>Class 5 for Yttria (Translucency around 49%)</li>
                                                <li>Single unit, to 3 unit bridges</li>
                                                <li>Chip resistant</li>
                                                <li>Fabricated with Cad-Cam Technology</li>
                                                <li>Approximately 750 mPa in strength</li>
                                                <li>Best alternative to Emax aesthetics using Zirconia</li>
                                            </ul>
                                        </div>
                                        <img className='all-ceramic-img-2' src='/img/xtml-disk.png' alt='XTML disk'/>
                                        
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        {solution.subsolutions && !showParentInfoWithChildren ? (
                        <div className='gallery-grid'>
                            {Object.entries(solution.subsolutions).map(([slug, subsolution]) => (
                            <NavButton
                                key={slug}
                                width={"40%"}
                                img={
                                Array.isArray(subsolution.img)
                                    ? (subsolution.img[0] || "/img/osseo-logo.png")
                                    : (subsolution.img || "/img/osseo-logo.png")
                                }
                                text={subsolution.title}
                                link={`${basePath}/${slug}`}
                            />
                            ))}
                        </div>
                        ) : (
                    
                        <>
                            {solution.video && <video muted autoPlay playsInline preload="auto" controls><source src={solution.video}/></video>}
                            {solution.img?.length > 0 && (
                            <div className='gallery-grid'>
                                {solution.img.map((src, index) => (
                                <img
                                    src={src}
                                    key={index}
                                    alt={solution.title}
                                    onClick={() => setSelectedImg(src)}
                                />
                                ))}
                            </div>
                            )}

                            {selectedImg && (
                            <div className='lightbox' onClick={() => setSelectedImg(null)}>
                                <img src={selectedImg} alt="Enlarged image" className='lightbox-img' />
                            </div>
                            )}

                            {solution.desc && <p className='solution-desc'>{solution.desc}</p>}
                            {solution.desc2 && <p className='solution-desc'>{solution.desc2}</p>}
                            {solution.desc3 && <p className='solution-desc'>{solution.desc3}</p>}
                            {showParentInfoWithChildren && solution.subsolutions && (
                            <div className='gallery-grid'>
                                {Object.entries(solution.subsolutions).map(([slug, subsolution]) => (
                                <NavButton
                                    key={slug}
                                    width={"40%"}
                                    img={
                                    Array.isArray(subsolution.img)
                                        ? (subsolution.img[0] || "/img/osseo-logo.png")
                                        : (subsolution.img || "/img/osseo-logo.png")
                                    }
                                    text={subsolution.title}
                                    link={`${basePath}/${slug}`}
                                />
                                ))}
                            </div>
                            )}

                            <div className='solution-details'>
                            {solution.offers && (
                                <div>
                                <h3 className='solutions-h3'>Offers</h3>
                                <ul className='solutions-ul'>
                                    {solution.offers.map((offer, i) => (
                                    <li key={i} className='solutions-li'>{offer}</li>
                                    ))}
                                </ul>
                                </div>
                            )}

                            {solution.materials && (
                                <div>
                                <h3 className='solutions-h3'>Materials</h3>
                                <ul className='solutions-ul'>
                                    {solution.materials.map((material, i) => (
                                    <li key={i} className='solutions-li'>{material}</li>
                                    ))}
                                </ul>
                                </div>
                            )}

                            {solution.features && (
                                <div>
                                <h3 className='solutions-h3'>Features</h3>
                                <ul className='solutions-ul'>
                                    {solution.features.map((feature, i) => (
                                    <li key={i} className='solutions-li'>{feature}</li>
                                    ))}
                                </ul>
                                </div>
                            )}

                            {solution.cons && (
                                <div>
                                <h3 className='solutions-h3'>Cons</h3>
                                <ul className='solutions-ul'>
                                    {solution.cons.map((con, i) => (
                                    <li key={i} className='solutions-li'>{con}</li>
                                    ))}
                                </ul>
                                </div>
                            )}
                            </div>
                        </>
                        )}
                    </>
                )}
                
                
                
            </main>
            <Footer/>
        </div>
    )

}
export default Solutions;